<div class="modal-header">
  <button type="button" class="close" (click)="preventSave()" data-toggle="modal" data-dismiss="modal" data-target="#closingConfirm" aria-label="Close">
    <span aria-hidden="true">×</span>
  </button>
  <h4 *ngIf="!isReadOnly" class="modal-title" i18n="@@ModifyReportDashboard">
    Modify a report / dashboard
  </h4>
  <!--I18 report dashbord-->
  <h4 *ngIf="isReadOnly" class="modal-title">
    <span>Report</span> & <span></span>Dashboard
  </h4>

  <div class="col-md-4">
    <div *ngIf="_editCustomName && !isReadOnly">
      <div class="form-group" id="inputGroupEditCustomName">
        <div class="input-group">
          <input type="text" class="form-control" id="editCustomName" value="{{ objectToEdit.customName }}" placeholder="Nom" [disabled]="!objectToEditIsLoad || isOnEdition" />
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" (click)="validCustomName()">
              <em class="fa fa-check"></em>
            </button>
          </span>
        </div>

        <span *ngIf="_ErrorMessageEditCustomName" class="help-block" i18n="@@PleaseConfirmYourChange">Please confirm your change.</span>
      </div>
    </div>
    <div *ngIf="!_editCustomName && !isReadOnly">
      <div>
        <div *ngIf="!haveChange">
          <strong>{{ objectToEdit?.customName }}</strong>&nbsp;
          <em *ngIf="objectToEditIsLoad" class="fa fa-pencil" (click)="editCustomName()"></em>

          <br />
        </div>
        <div *ngIf="haveChange">
          <strong class="text-danger">
            <em>
              {{ objectToEdit?.customName
              }}<span *ngIf="haveChange" class="text-danger"> *</span>
            </em></strong>&nbsp;
        </div>

        <small>{{ objectToEdit?.azureObjectId }}</small>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="checkbox mt-15">
      <label>
        <input type="checkbox" [disabled]="!objectToEditIsLoad || isOnEdition || isReadOnly" [checked]="isCubeConnection" (change)="toggleIsCubeConnection()" />
        <span i18n="@@HasAConnectionToTheCube">Has a connection to the cube</span>
      </label>
    </div>
    <div class="checkbox mt-15">
      <label>
        <input type="checkbox" [disabled]="!objectToEditIsLoad || isOnEdition || isReadOnly" [checked]="displayFilterTable" (change)="toggleDisplayFilterTable()" />
        <span i18n="@@DisplayTheFiltersTable">Display the filters table</span>
      </label>
    </div>
  </div>

  <div class="col-md-4">
    <div *ngIf="haveChange" class="text-center">
      <!--I18 nosaved-->
      <p class="text-danger">Unsaved</p>
    </div>
    <div *ngIf="_roleEditErrorMessage" class="text-center">
      <p class="text-danger" i18n="@@PleaseFinalizeYourRoleEntry">
        Please finalize your role entry.
      </p>
    </div>
    <div *ngIf="
        (objectToEdit.roles.length <= 0 && objectToEditIsLoad) || !objectIsInAPI
      " class="text-center">
      <em i18n="@@NoConfiguration">No configuration</em>
    </div>
    <!-- <div *ngIf="!objectIsInAPI" class="text-danger"><i class="fa fa-warning "></i><em>This report is not recorder in the API</em></div> -->
  </div>
</div>
<!-- Modal-Header -->

<div class="modal-content" id="scrollableReportModelContent">
  <div class="row col-md-12 box-unset">
    <div class="nav-tabs-custom">
      <ul [class.disabled]="haveChange" class="nav nav-pills" id="report-tabs-pills">
        <li class="active">
          <a data-target="#tab_1" data-toggle="tab" i18n="@@Configurations">Configurations</a>
        </li>
        <li>
          <a data-target="#tab_2" data-toggle="tab" i18n="@@ConsultationHistory">Access history</a>
        </li>
        <li *ngIf="objectToEdit.roles.length > 0">
          <a data-target="#tab_3" data-toggle="tab">Transfert</a>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane active" id="tab_1">
          <table id="dtScrollContainer" class="table table-striped table-bordered table-sm scrollable-sticky-container">
            <caption class="hidden"></caption>
            <tr id="StickyDtHeader" class="sticky">
              <th id="configurationDashboardHeader">
                <div  class="col-md-3 ma va-m">
                  <span class="mr-2" i18n="@@Role">Role</span>
                  <i class="fa col" [class.fa-arrow-up]="rolesAreAsc" [class.fa-arrow-down]="!rolesAreAsc" (click)="sortRoles()"></i>
                </div>
                  <div class="col-md-6 ma va-m">
                      <!-- Zone de filtre -->
                      <!-- <label for="roleFilter" class="sr-only">?</label> -->
                      <input type="text" id="roleFilter" class="form-control" [(ngModel)]="roleFilter" placeholder="Filtrer les rôles" />

                  </div>

                <div class="col-md-3 text-right ma b0 t0 ">
                  <a *ngIf="
                      (!isOnEdition && objectToEditIsLoad && !isReadOnly) ||
                      (!isOnEdition && !objectIsInAPI)
                    " class="btn btn-default btn-sm" (click)="openPopEditForAddRole('')">
                    <em class="fa fa-plus"></em>
                    <span i18n="@@Add"> Add</span>
                  </a>
                </div>
              </th>
              <th i18n="@@UsersGroups">Users / Groups</th>
              <th i18n="@@Actions">Actions</th>
            </tr>

            <tbody *ngIf="objectToEdit.roles.length > 0; else loadingUserAndGroup">
              <!-- <tr *ngFor="let role of objectToEdit.roles; index as i"> -->
              <tr *ngFor="let role of filteredRoles(); index as i">
                <td class="col-xs-5 va-m">
                  <ul class="list-unstyled">
                    {{
                    role.theRole
                    }}
                    <em>(expected {{ role.usersOrGroups.length }}) </em><br />
                    <small *ngIf="role.modifiedByUserOrGroup"><span i18n="@@LastUpdate:">Last update:</span>
                      {{ role.modifiedOn | date : "dd/MM/yyyy HH:mm" }}
                      <span i18n="@@by">by</span>
                      {{ role.modifiedByUserOrGroup.userGivenName }}
                      {{ role.modifiedByUserOrGroup.userSurname }}</small>
                  </ul>
                </td>

                <td class="col-xs-4">
                  <ul class="list-unstyled">
                    <li *ngFor="let userOrGroup of role.usersOrGroups; index as y">
                      <div *ngIf="userOrGroup.isUser">
                        <span class="badge badge-primary"><em class="fa fa-user"></em>{{ userOrGroup.name }}</span><br />
                        <!-- <span class="label label-primary"><em class="fa fa-user"></em>{{ userOrGroup.name }}</span><br /> -->
                      </div>
                      <div *ngIf="userOrGroup.isGroup">
                        <span class="badge badge-default"><em class="fa fa-group"></em>{{ userOrGroup.name }}</span><br />
                        <!-- <span class="label label-default"><em class="fa fa-group"></em>{{ userOrGroup.name }}</span><br /> -->
                      </div>
                    </li>
                  </ul>
                </td>

                <td *ngIf="!isReadOnly" class="col-xs-1 text-center">
                  <button type="submit" class="btn btn-xs btn-warning mr-5" [disabled]="isOnEdition" (click)="
                      isOnEdition = true;
                      submitDisabled = true;
                      editRole(i);
                      showRowForm('')
                    ">
                    <em class="fa fa-edit"></em>
                  </button>
                  <button type="submit" class="btn btn-xs btn-danger mr-5" [disabled]="isOnEdition" (click)="isOnEdition = true; openDeleteConfirmModal(i)" data-toggle="modal" data-target="#deleteConfirm">
                    <em class="fa fa-remove"></em>
                  </button>
                </td>
              </tr>
            </tbody>

            <ng-template #loadingUserAndGroup>
              <tbody class="text-centered">
                <tr>
                  <td>
                    <span *ngIf="!objectToEditIsLoad && objectIsInAPI"><em class="fa fa-spinner fa-pulse fa-3x fa-fw"></em>&nbsp;<span i18n="@@InProgress">In progress</span></span>
                    <span *ngIf="
                        (objectToEditIsLoad &&
                          objectToEdit.roles.length == 0 &&
                          objectIsInAPI) ||
                        !objectIsInAPI
                      " i18n="@@NoResultsFound">No results found</span>
                  </td>
                </tr>
              </tbody>
            </ng-template>
          </table>
        </div>
        <div class="tab-pane" id="tab_2">
          <table datatable aria-describedby="roles access historic" [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th id="tab_2_role" i18n="@@Role">Role</th>
                <th id="tab_2_email" i18n="@@Email">Email</th>
                <th id="tab_2_view" i18n="@@LastView">Last view</th>
              </tr>
            </thead>
            <tbody *ngIf="objectToEditIsLoad; else loadingAccess">
              <tr *ngFor="let accessLog of objectToEdit.accessLog; index as i">
                <td>
                  <em>{{ accessLog.roleName }}</em>
                </td>
                <td>
                  {{ accessLog.userOrGroup.userSurname }}
                  {{ accessLog.userOrGroup.userGivenName }}
                </td>
                <td>{{ accessLog.viewAt | date : "dd/MM/yyyy HH:mm" }}</td>
              </tr>
              <span *ngIf="objectToEdit.accessLog == 0" i18n="@@NoResultsFound">No results found</span>
            </tbody>
          </table>
          <ng-template #loadingAccess>
            <tbody class="text-centered">
              <tr>
                <td *ngIf="_isAdd == false">
                  <span *ngIf="!objectToEditIsLoad && _isAdd"><em class="fa fa-spinner fa-pulse fa-3x fa-fw"></em>&nbsp;<span i18n="@@InProgress">In progress</span></span>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </div>
        <!-- <div *ngIf="isReadOnly" class="tab-pane"id="tab_3"> -->
        <div class="tab-pane" id="tab_3">
          <div class="tab-content">
            <h1>Tranfert de roles</h1>
            <div class="col-md-6">
              <div *ngIf="emptyReportlist" class="form-group w-100">
                <select2 id="formUsers" (valueChanged)="selectEmptyReport($event.value)" [width]="347" [options]="Select2Options" multiple="true" tabindex="-1" aria-hidden="true">
                  <option value="0" i18n="@@Search">Search…</option>
                  <option data-group="0" data-icon="fa-group" [value]="report.azureObjectId" [ngValue]="report.azureObjectId" *ngFor="let report of emptyReportlist">
                    {{ report.customName }}
                  </option>
                </select2>
              </div>
            </div>
            <div class="col-md-6">
              <button type="button" [disabled]="!selectedEmptyReport" class="btn btn-warning" (click)="openTransfertConfirmModal()" data-toggle="modal" data-target="#transfertConfirm">
                Transferer
              </button>
            </div>
            <textarea class="form-control">{{ jsonRoles }}</textarea>

            <button type="submit" class="btn btn-xs btn-succes" [disabled]="isOnEdition" (click)="getJsonRoles()">
              <em class="fa fa-print"></em>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <!-- affichage edit -->
  <div class="{{ showEditOrAddRoleRow }} col-12" id="UserAndRoleMgr">
    <div id="groupFormParametersContainer">
      <div class="form-group {{ groupFormParametersBehaviorClass }} col-md-8" id="groupFormParameters">
        <input class="form-control" id="formParameters" [disabled]="!isOnCreation" [style.pointer-events]="isOnCreation ? 'auto' : 'none'" placeholder="Rôle" type="text" required (keyup)="checkRoleName($event.target.value)" (change)="checkRoleName($event.target.value); haveChange = true" />
        <p *ngIf="!isRoleToAddOrEditHave_WithoutRole_ && isOnCreation">
          <em>
            <span i18n="@@RoleInYourReportDashboard">No role in your report / dashboard?</span>
            <a (click)="setReportOrDashboardWithoutRole()" i18n="@@ClickHere">Click here</a>.
          </em>
        </p>
        <span *ngIf="errorFormParameter" class="help-block">{{
          errorFormParameter
          }}</span>
      </div>
      <div class="col-md-4 text-right" id="edit-close-container">
        <div id="div-edit-close">
          <span>
            <em id="div-edit-close-annotation">Annuler les changements et fermer ...</em>
            <button class="close btn btn-xs" id="btn-cancel-edit-role" (click)="cancelEditRole()">
              <i class="fa fa-close" aria-hidden="true" data-tooltip="Annuler les changements et fermer"></i>
            </button>
          </span>
        </div>
        <div id="div-edit-close-btn-container">
          <button class="btn btn-success" id="btn-send-role" (click)="sendRole()" i18n="@@Send" [disabled]="haveRoleNameError">
            Send
          </button>
        </div>
      </div>
    </div>

    <div id="tagScrollContainer" class="scrollable-sticky-container">

      <div id="tagFormStickyContainer" class="sticky">
        <input type="text" class="form-control tag-input" [(ngModel)]="tagInput" (input)="filterOptions()" (keydown)="onKeyDown($event)" placeholder="Ajoutez un User/Group" [disabled]="haveRoleNameError" />
        <div #UserOrGroupSuggestorContainer id="suggestions" *ngIf="filteredOptions.length > 0" class="autocomplete-suggestions">
          <div *ngFor="let option of filteredOptions; let $i = index" [ngClass]="{ selected: $i == uogSelectedIndex }" [attr.data-index]="$i" (click)="addTag(option)" (mouseover)="setSelectedIndex($i)" class="autocomplete-item">
            <i [ngClass]="option.isUser ? 'fa fa-user' : 'fa fa-group'"></i>
            {{ option.name }}
          </div>
        </div>

      </div>

      <div class="col-12" id="div-users-or-groups">
        <div *ngFor="let UserOrGroup of RoleToAddOrEdit.usersOrGroups">
          <span *ngIf="UserOrGroup.isUser" class="text-left col-md-2 btn-xs">
            <span class="badge badge-primary tag" [ngClass]="{ newUser: UserOrGroup.isNew }">
              <em class="fa fa-close" (click)="removeUserOrGroup(UserOrGroup)"></em>
              &nbsp;<em class="fa fa-user"></em> {{ UserOrGroup.name }}
            </span>
          </span>
          <span *ngIf="UserOrGroup.isGroup" class="text-left col-md-2 btn-xs">
            <span class="badge badge-default tag" [ngClass]="{ newGroup: UserOrGroup.isNew }">
              <em class="fa fa-close" (click)="removeUserOrGroup(UserOrGroup)"></em>
              &nbsp;<em class="fa fa-group"></em> {{ UserOrGroup.name }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isReadOnly" class="d-flex col-md-12" id="modal-footer-bottom-banner">
    <button type="button" class="btn btn-default pull-left cancel-button" data-dismiss="modal" (click)="closeModal()">
      <i class="fa fa-undo arrow-icon" aria-hidden="true"> </i>
      <span i18n="@@cancel"> Cancel</span>
    </button>

    <button type="submit" [disabled]="submitDisabled" (click)="onSubmit()" class="btn btn-success" i18n="@@Save">
      Save
    </button>
  </div>

  <!-- Transfert Confirm Modal -->
  <div class="modal" id="transfertConfirm" tabindex="-1" role="dialog" aria-labelledby="transfertConfirm" aria-hidden="true" [ngClass]="{ show: showTransfertConfirmModal }">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header confirm-modal-header">
          <h5 class="modal-title text-centered" id="transfertConfirmTitle">
            <span class="fa fa-question-circle"></span> <span> TRANSFERT </span><span class="fa fa-question-circle"></span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeTransfertConfirmModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-centered" i18n="@@PleaseConfirmYourChange">
          Please confirm your change.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary pull-left cancel-button" data-dismiss="modal" (click)="cancelTransfertRole()">
            <i class="fa fa-undo arrow-icon mr-5" aria-hidden="true"></i><span i18n="@@cancel">Cancel</span>
          </button>
          <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="confirmTransfertRole()" i18n="@@confirm">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Deletion Confirm Modal -->
  <div class="modal" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="deleteConfirm" aria-hidden="true" [ngClass]="{ show: showDeleteConfirmModal }">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header confirm-modal-header">
          <h5 class="modal-title text-centered" id="deleteConfirmTitle">
            <span class="fa fa-exclamation-circle"></span>
            <span i18n="@@deletion"> DELETION </span><span class="fa fa-exclamation-circle"></span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDeleteConfirmModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-centered" i18n="@@PleaseConfirmYourChange">
          Please confirm your change.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary pull-left cancel-button" data-dismiss="modal" (click)="cancelDeleteRole()">
            <i class="fa fa-undo arrow-icon mr-5" aria-hidden="true"></i><span i18n="@@cancel">Cancel</span>
          </button>
          <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="confirmDeleteRole()" i18n="@@confirm">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Close Confirm Modal -->
  <div class="modal" id="closingConfirm" tabindex="-1" role="dialog" aria-labelledby="closingConfirm" aria-hidden="true" [ngClass]="{ show: showClosingConfirmModal }">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header confirm-modal-header">
          <!--I18 closing-->
          <h5 class="modal-title text-centered" id="closingConfirmTitle">
            <span class="fa fa-exclamation-circle"></span>
            <span> CLOSING </span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeClosingConfirmModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-centered" i18n="@@PleaseConfirmYourChange">
          Please confirm your change.
        </div>
        <div class="modal-footer modal-footer-buttons">
          <button type="button" class="btn btn-secondary btn-sm cancel-button" data-dismiss="modal" (click)="closeClosingConfirmModal()">
            <i class="fa fa-undo arrow-icon mr-5" aria-hidden="true"></i>Cancel
            - Return
          </button>

          <button type="button" class="btn btn-danger btn-sm quit-button" data-dismiss="modal" (click)="closeModal()">
            Quit without saving
          </button>

          <button type="button" class="btn btn-primary btn-xl save-button" data-dismiss="modal" (click)="saveAndQuit()" i18n="@@save">
            Save & Quit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
